"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Feed_instances, _Feed_strTimeInSec;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feed = void 0;
const media_1 = require("../classes/media");
class Feed {
    constructor(rawData = {
        id: 0,
        stream_id: 0,
        show_in_feed: false,
        payable: false,
        pinned: false,
        pinned_from: null,
        pinned_to: null,
        first_from: null,
        first_to: null,
        link: null,
        link_open_in: '_blank',
        image: null,
        image_link: null,
        title: '',
        description: null,
        alternate_text: null,
        price: null,
        sales_price: null,
        sku: null,
        ordno: null,
        quantity: null,
        variations: null,
        cta: null,
        card_click_tracking: null,
        link_click_tracking: null,
        created: null,
        updated: null,
        uniqueKey: null,
        owner_id: 0,
        migrated: false,
        created_at: null,
        updated_at: null,
    }) {
        _Feed_instances.add(this);
        this.id = rawData.id;
        this.stream_id = rawData.stream_id;
        this.show_in_feed = rawData.show_in_feed;
        this.payable = rawData.payable;
        this.pinned = rawData.pinned;
        this.pinned_from = rawData.pinned_from;
        this.pinned_to = rawData.pinned_to;
        this.first_from = rawData.first_from;
        this.first_to = rawData.first_to;
        this.link = rawData.link;
        this.link_open_in = rawData.link_open_in;
        this.image_link = rawData.image_link;
        if (rawData.image !== null && Object.prototype.toString.call(rawData.image) === '[object Object]') {
            this.image = new media_1.Media(rawData.image.id, rawData.image.url, rawData.image.thumbnail_url);
        }
        else {
            this.image = null;
        }
        this.title = rawData.title;
        this.description = rawData.description;
        this.alternate_text = rawData.alternate_text;
        this.price = rawData.price;
        this.sales_price = rawData.sales_price;
        this.sku = rawData.sku;
        this.ordno = rawData.ordno;
        this.quantity = rawData.quantity;
        this.variations = rawData.variations;
        this.cta = rawData.cta;
        this.card_click_tracking = rawData.card_click_tracking;
        this.link_click_tracking = rawData.link_click_tracking;
        this.owner_id = rawData.owner_id;
        this.migrated = rawData.migrated;
        this.created_at = rawData.created_at;
        this.updated_at = rawData.updated_at;
        this.created = rawData.created || new Date();
        this.updated = rawData.updated || new Date();
        if (typeof rawData.uniqueKey === 'string' && rawData.uniqueKey.length > 0) {
            this.uniqueKey = rawData.uniqueKey;
        }
        else if (typeof rawData.uniqueKey === 'undefined' || rawData.uniqueKey === null || rawData.uniqueKey === '') {
            this.uniqueKey = Math.random().toString(36).slice(2);
        }
        else {
            this.uniqueKey = rawData.uniqueKey || null;
        }
    }
    get pinned_from_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.pinned_from);
    }
    get pinned_to_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.pinned_to);
    }
    get first_from_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.first_from);
    }
    get first_to_in_sec() {
        return __classPrivateFieldGet(this, _Feed_instances, "m", _Feed_strTimeInSec).call(this, this.first_to);
    }
}
exports.Feed = Feed;
_Feed_instances = new WeakSet(), _Feed_strTimeInSec = function _Feed_strTimeInSec(time) {
    if (typeof time !== 'string' || time.indexOf(':') === -1) {
        return null;
    }
    const parts = time.split(':');
    if (parts.length !== 3) {
        return null;
    }
    let result = 0;
    result += parseInt(parts[0]) * 3600;
    result += parseInt(parts[1]) * 60;
    result += parseInt(parts[2]);
    return result;
};
//# sourceMappingURL=feed.js.map